(function componentForm($, Adzuki)
{
	"use strict";

	var share_form = {
		name: 'LivePlannerHistoryShare',
	}, share_recipients = [];

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(share_form);
	});
	
	/**
	 * Load function for Share Session Summary form
	 * @param $form
	 */
	share_form.load = function load($form) {
		$('#liveplannerhistoryshare-to').focusout(function _addRecipients() {
			loseFocus($(this).val());
		});
		
		$('.live-planner-landing').on('click', '.fit-email-list', function _removeEmail() {
			var email = $(this).data('email'),
				index = share_recipients.indexOf(email);
			
			if (index !== -1) {
				share_recipients.splice(index, 1);
			}
			
			$('#liveplannerhistoryshare-recipients').val(JSON.stringify(share_recipients));
			
			if (share_recipients.length >= 1) {
				$('.email-list').removeClass('hidden');
				populateEmailVisualList();
			} else {
				$('.email-list').addClass('hidden');
			}
		});
	};
	
	/**
	 *
	 */
	function populateEmailVisualList()
	{
		var html = '', i;
		for (i = 0; i< share_recipients.length; i++) {
			html += '<span class="fit-email-list" data-email="' + share_recipients[i] + '">' + share_recipients[i] + ' <i class="far fa-times-circle"></i></span>';
		}
		$('.email-list-contents').html(html);
	}
	
	/**
	 *
	 * @param email
	 */
	function loseFocus(email)
	{
		if (email.length > 0) {
			if (Adzuki.String.isEmail(email)) {
				share_recipients.push(email);
				$('#liveplannerhistoryshare-to').val('');
			} else {
				Adzuki.StatusMessage('error', 'Sorry ' + email + ' is not a valid email address');
			}
			
			$('#liveplannerhistoryshare-recipients').val(JSON.stringify(share_recipients));
		}
		
		if (share_recipients.length >= 1) {
			$('.email-list').removeClass('hidden');
			populateEmailVisualList();
		} else {
			$('.email-list').addClass('hidden');
		}
	}
}(jQuery, window.Adzuki || {}));
